import { getYouTubeEmbedUrl } from '@/src/utils/youtube';
import { Dialog, DialogContent } from '@workspace/ui/components/dialog';

interface YouTubeModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoId: string;
  title?: string;
  channelTitle?: string;
}

export const YouTubeModal: React.FC<YouTubeModalProps> = ({
  isOpen,
  onClose,
  videoId,
  title,
}) => {
  const embedUrl = getYouTubeEmbedUrl(videoId, {
    autoplay: true,
    mute: false,
  });

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="p-2 gap-0 min-w[90vw] min-h[240px] md:min-h[500px] max-w[90vw] max-h-1/2 h-[500px] w-[90vw] bg-black border-blue-primary"
        style={{
          height: '50vh',
          maxHeight: '70vh',
        }}
      >
        <div className="md:w-full md:h-full h-full w-[85vw]">
          <iframe
            src={embedUrl}
            title={title || 'YouTube Video'}
            className="bg-white w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
